import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="loading-indicator"
// For file downloads, use data-loading-indicator-timeout-value="3000" to auto-hide after 3 seconds
export default class extends Controller {
  static targets = ["spinner", "text"];
  static values = {
    timeout: { type: Number, default: 0 },
  };

  connect() {
    // If this controller is on a form, automatically handle loading states
    if (this.element.tagName === "FORM") {
      this.element.addEventListener(
        "turbo:submit-start",
        this.showSpinner.bind(this)
      );
      this.element.addEventListener(
        "turbo:submit-end",
        this.hideSpinner.bind(this)
      );
    }
  }

  disconnect() {
    this.clearAutoHideTimer();

    if (this.element.tagName === "FORM") {
      this.element.removeEventListener(
        "turbo:submit-start",
        this.showSpinner.bind(this)
      );
      this.element.removeEventListener(
        "turbo:submit-end",
        this.hideSpinner.bind(this)
      );
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }

    if (this.hasTextTarget) {
      this.textTarget.classList.add("hidden");
    }

    // For file downloads: auto-hide after timeout (if configured)
    if (this.timeoutValue > 0) {
      this.clearAutoHideTimer();
      this.autoHideTimer = setTimeout(() => {
        this.hideSpinner();
      }, this.timeoutValue);
    }
  }

  hideSpinner() {
    this.clearAutoHideTimer();

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }

    if (this.hasTextTarget) {
      this.textTarget.classList.remove("hidden");
    }
  }

  clearAutoHideTimer() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
      this.autoHideTimer = null;
    }
  }
}
